module.exports = __webpack_public_path__ + "img/barryIcon.d6a45f01.png";